<template>
  <div v-if="isOpen" class="modal-container">
    <div
      class="fixed inset-0 bg-background/50 backdrop-blur-sm z-40"
      @click="$emit('close')"
    ></div>
    <div
      class="modal-content w-full max-w-md relative bg-white dark:bg-card m-auto flex-col flex rounded-2xl z-50 shadow-xl border border-border overflow-hidden"
    >
      <!-- Header -->
      <div
        class="w-full flex justify-between items-center px-6 py-4 border-b border-border"
      >
        <h2 class="text-[18px] font-semibold text-foreground">
          Create Learning Goal
        </h2>
        <button
          @click="$emit('close')"
          class="p-1 hover:bg-muted rounded-full transition-colors text-muted-foreground"
        >
          <X :size="20" />
        </button>
      </div>

      <!-- Content -->
      <div class="px-6 py-8 flex flex-col items-center text-center">
        <!-- Credit Count -->
        <h3 class="text-[48px] font-bold text-foreground leading-none mb-1">
          {{ availableCredits }}
        </h3>
        <p class="text-sm font-medium text-muted-foreground mb-6">
          Credits available
        </p>

        <!-- Message -->
        <p class="text-[15px] text-foreground font-medium max-w-[280px]">
          <span v-if="availableCredits < cost">
            This learning goal would cost you {{ cost }} ES credits. Would you
            like to top up your credits?
          </span>
          <span v-else>
            This learning goal would cost you {{ cost }} ES credits. Click
            continue to proceed
          </span>
        </p>
      </div>

      <!-- Footer Actions -->
      <div class="px-6 pb-8 pt-2">
        <!-- Scenario: Insufficient Credits -->
        <div v-if="availableCredits < cost" class="flex items-center gap-3">
          <button
            type="button"
            class="flex-1 py-3 px-4 bg-transparent border border-border text-foreground rounded-full hover:bg-muted transition-all font-semibold text-sm h-12"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="button"
            class="flex-1 py-3 px-4 bg-foreground text-background rounded-full hover:bg-foreground/90 transition-all font-semibold text-sm h-12 shadow-sm"
            @click="$emit('top-up')"
          >
            Yes, top-up credits
          </button>
        </div>

        <!-- Scenario: Sufficient Credits -->
        <div v-else class="w-full">
          <button
            type="button"
            :disabled="isProcessing"
            class="w-full py-3 px-4 bg-foreground text-background rounded-full hover:bg-foreground/90 transition-all font-semibold text-sm h-12 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            @click="$emit('continue')"
          >
            <span
              v-if="isProcessing"
              class="flex items-center justify-center gap-2"
            >
              <span
                class="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-current"
              ></span>
              Processing...
            </span>
            <span v-else>Continue</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { X } from "lucide-vue-next";

export default {
  name: "GoalCreditModal",
  components: {
    X,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    availableCredits: {
      type: Number,
      required: true,
    },
    cost: {
      type: Number,
      default: 10,
    },
    isProcessing: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  animation: modalScale 0.2s ease-out;
}

@keyframes modalScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
